import { Col, Row } from "antd";
import styles from "./BackendPage.module.scss";
import cubesImg from "../../assets/images/backend_cubes.jpg";
// import Slider from "react-slick";
import { ReactElement, useEffect, useState } from "react";
import { useSize } from "ahooks";
import { useTranslation } from "react-i18next";
import SliderWrapper from "../../components/CarouselPage/CarouselModal";
export function BackendDevelopment() {
  const { t } = useTranslation();
  const size = useSize(document.querySelector("body"));
  // const appendDots = (dots: React.ReactNode): React.ReactNode => (
  //   <div>
  //     <ul className={styles.customDotsContainer}>{dots}</ul>
  //   </div>
  // );
  const customPaging = (i: number): React.ReactNode => (
    <div className={styles.customDot} />
  );
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    dots: true,
    arrows: false,
    // appendDots,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: true,
    beforeChange: (current: number, next: number) => {
      setCurrentSlide(next);
    },
    customPaging: (i: any) => (
      <div
        className={`${styles.dotStyle} ${
          i === currentSlide ? styles.activeDot : ""
        }`}
      ></div>
    ),
  };

  return (
    <div className={styles.pageWrapper}>
      <Row className={styles.descWrapper}>
        <Col span={12} className={styles.description}>
          <div className={styles.columnTitle}>{t("Backend.headTitle")}</div>
          <p className={styles.developmentText}>
            {t("Backend.headDescription")}
          </p>
        </Col>
      </Row>
      <div className={styles.wrapperKey}>
        <div className={styles.columnKeyTitle}>
          {t("Backend.keyComponentsTitle")}
        </div>
        <div className={styles.keyContent}>
          <div className={styles.keyColumn}>
            <>
              <div className={styles.keysTitle}> Server:</div>
              <p className={styles.keysText}>
                {t("Backend.serverDescription")}
                <strong className={styles.keysText}>
                  Node.js, Python, Ruby on Rails, Java, PHP,
                </strong>{" "}
                {t("Backend.andMore")}
              </p>
            </>
          </div>
          <div className={styles.keyColumn}>
            <>
              <div className={styles.keysTitle}>
                {t("Backend.dataBasesTitle")}:
              </div>
              <p className={styles.keysText}>
                {t("Backend.DataBaseDescription1")}
                <strong className={styles.keysText}>
                  {" "}
                  SQL databases (e.g., MySQL, PostgreSQL) and NoSQL databases
                  (e.g., MongoDB, Redis).
                </strong>{" "}
                {t("Backend.DataBaseDescription2")}
              </p>
            </>
          </div>
          <div className={styles.keyColumn}>
            <>
              <div className={styles.keysTitle}>API:</div>
              <p className={styles.keysText}>
                {t("Backend.ApiDescription")}
                <strong className={styles.keysText}>
                  {" "}
                  RESTful APIs and GraphQL
                </strong>{" "}
                {t("Backend.apiEnding")}
              </p>
            </>
          </div>
        </div>
      </div>

      <div className={styles.backendSlider}>
        <div className={styles.securityWrapper}>
          <div className={styles.sliderWrapper}>
            <SliderWrapper {...settings}>
              <div className={styles.securityCol}>
                <div className={styles.securityTitle}>
                  {" "}
                  {t("Backend.securityTitle")}
                </div>
                <p className={styles.keyComponentsText}>
                  {t("Backend.securityDescription")}
                </p>
              </div>{" "}
              <div className={styles.securityCol}>
                <div className={styles.securityTitle}>
                  {t("Backend.scalabilityTitle")}
                </div>
                <p className={styles.keyComponentsText}>
                  {t("Backend.scalabilityDescription")}
                </p>
              </div>{" "}
              <div className={styles.securityCol}>
                {" "}
                <div className={styles.securityTitle}>
                  {t("Backend.serverManagementTitle")}
                </div>
                <p className={styles.keyComponentsText}>
                  {t("Backend.serverManagementDescription")}
                </p>
              </div>
            </SliderWrapper>
          </div>
        </div>
      </div>

      <div className={styles.backendDesktop}>
        <Row className={styles.securityWrapper}>
          <div className={styles.overlayWrap}>
            <Col className={styles.securityCol}>
              <div className={styles.securityTitle}>
                {" "}
                {t("Backend.securityTitle")}
              </div>
              <p className={styles.keysText}>
                {t("Backend.securityDescription")}
              </p>
            </Col>{" "}
            <Col className={styles.securityCol}>
              <div className={styles.securityTitle}>
                {t("Backend.scalabilityTitle")}
              </div>
              <p className={styles.keysText}>
                {t("Backend.scalabilityDescription")}
              </p>
            </Col>{" "}
            <Col className={styles.securityCol}>
              {" "}
              <div className={styles.securityTitle}>
                {t("Backend.serverManagementTitle")}
              </div>
              <p className={styles.keysText}>
                {t("Backend.serverManagementDescription")}
              </p>
            </Col>
          </div>
        </Row>
      </div>
      <div className={styles.cubesWrapper}>
        <div className={styles.cubesRow}>
          <div className={styles.cubesCol}>
            <div className={styles.cubesTitle}>
              {t("Backend.serverSideTitle")}
            </div>{" "}
            <p className={styles.keysText}>
              {t("Backend.serverSideDescription")}
            </p>
          </div>{" "}
          <div className={styles.cubesCol}>
            <div className={styles.cubesTitle}> {t("Backend.authTitle")}</div>{" "}
            <p className={styles.keysText}>{t("Backend.authDescription")}</p>
          </div>
        </div>
        <div className={styles.cubes}>
          <img src={cubesImg} style={{ maxWidth: "none" }} />
        </div>
      </div>
      <div className={styles.testingDocumentation}>
        <div className={styles.testingCol}>
          <div className={styles.securityTitle}>
            {" "}
            {t("Backend.testingTitle")}{" "}
          </div>{" "}
          <p className={styles.keysText}>{t("Backend.testingDescription")}</p>
        </div>{" "}
        <div className={styles.documentCol}>
          <div className={styles.securityTitle}>
            {" "}
            {t("Backend.documentationTitle")}
          </div>{" "}
          <p className={styles.keysText}>
            {t("Backend.documentationDescription")}
          </p>
        </div>
      </div>
      <Row className={styles.lastText}>
        <p className={styles.footerText}>{t("Backend.backendFooter")}</p>
      </Row>
    </div>
  );
}
